// src/components/AddUser.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddUser = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [walletAmount, setWalletAmount] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddUser = async (e) => {
    e.preventDefault();

    console.log("Form Submitted With Data:", { email, password, role, walletAmount });

    // Validation
    if (!email || !password || !role || walletAmount === '') {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        'https://software.tabtrips.com/api/add_user.php',
        JSON.stringify({
          email,
          password,
          role,
          walletAmount: parseFloat(walletAmount) || 0.00,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log("Server Response:", response.data);

      if (response?.data?.status === 'success') {
        toast.success('User added successfully!');
        setEmail('');
        setPassword('');
        setRole('');
        setWalletAmount('');
      } else {
        toast.error(response.data.message || 'Failed to add user.');
      }
    } catch (error) {
      console.error("Error Adding User:", error);

      if (error.response) {
        toast.error(`Server Error: ${error.response.statusText}`);
      } else if (error.request) {
        toast.error("No response from server. Try again later.");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={headerStyle}>Add New User</h2>
        <form onSubmit={handleAddUser}>
          {/* Email */}
          <label style={labelStyle}>Email</label>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />

          {/* Password */}
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />

          {/* Role */}
          <label style={labelStyle}>Role</label>
          <select value={role} onChange={(e) => setRole(e.target.value)} style={{ ...inputStyle }}>
            <option value="">Select Role</option>
            <option value="admin">Admin</option>
            <option value="user">User</option>
            <option value="manager">Manager</option>
            <option value="ojo">Ojo</option>
          </select>

          {/* Wallet Amount */}
          <label style={labelStyle}>Wallet Amount (₹)</label>
          <input
            type="number"
            step="0.01"
            min="0"
            placeholder="Enter wallet amount"
            value={walletAmount}
            onChange={(e) => setWalletAmount(e.target.value)}
            style={inputStyle}
          />

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              ...buttonStyle,
              backgroundColor: loading ? '#94a3b8' : '#3182ce',
            }}
          >
            {loading ? 'Adding...' : 'Add User'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddUser;

// 💡 Style Objects remain unchanged
const containerStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(to bottom right, #1a202c, #2d3748)',
  padding: '1rem',
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
};

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: '1rem',
  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  width: '100%',
  maxWidth: '400px',
  padding: '2rem',
  boxSizing: 'border-box',
};

const labelStyle = {
  fontSize: '0.9rem',
  fontWeight: '600',
  color: '#2d3748',
  marginBottom: '0.5rem',
  display: 'block',
};

const inputStyle = {
  width: '100%',
  padding: '0.75rem 1rem',
  border: '1px solid #cbd5e0',
  borderRadius: '0.5rem',
  fontSize: '1rem',
  marginBottom: '1.25rem',
  boxSizing: 'border-box',
};

const buttonStyle = {
  width: '100%',
  padding: '0.75rem 1rem',
  borderRadius: '0.5rem',
  fontWeight: '600',
  fontSize: '1rem',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
};

const headerStyle = {
  fontSize: '1.5rem',
  fontWeight: '700',
  textAlign: 'center',
  marginBottom: '1.5rem',
};